<div class="overflow-y-auto summary-page-bg" [ngClass]="isBigScreen? 'height-100' : 'height-80'" #pageContent
    (scroll)="onScrollEvent()">
    <div class="row col-12 padding-top-5 padding-bottom-5 padding-left-0 padding-right-0">
        <div class="row col-12 col-lg-6 padding-left-0" *ngIf="matterTypeText">
            <div class="col-12">
                <span class="header">{{matterTypeText}}: </span>
                <span *ngIf="!matterInfo?.isCustomMatter()">{{propertyAddressText}}</span>
                <span *ngIf="matterInfo?.isCustomMatter()">{{matterInfo.legalDescription}}</span>
            </div>

        </div>
        <div class="row col-12 col-lg-3 padding-left-0 " *ngIf="closingDateText">
            <div class="col-12">
                <span class="header">{{matterInfo.isCustomMatter() ? 'Completing:' : 'Closing:'}}</span>
                <span>{{closingDateText}}</span>
            </div>
        </div>
        <div class="row col-12 col-lg-3 padding-left-0 " *ngIf="matterInfo?.fileStatus">
            <div class="col-12">
                <span class="header">File Status:</span>
                <span>{{matterInfo?.fileStatus}}</span>
            </div>
        </div>
    </div>
    <div class="row col-12">
        <div class="row col-12 col-lg-8 padding-left-0">
            <mat-card class="mat-card-block"
                *ngIf="isOutstandingIconVisible() && (isSelectedSection('OUTSTANDING') || isBigScreen)">
                <mat-card-title class="mat-card-header display-block padding-bottom-0">
                    <span class="padding-left-10"><i class="fa fa-clock padding-right-10 primary"></i>Outstanding</span>
                </mat-card-title>

                <div class="col-12 padding-bottom-10">
                    <ng-container
                        *ngFor="let matterInformationExchangeTransaction of getOutstandingSharedDocumentsTransactions()">
                        <div class="padding-bottom-5 padding-top-5 border-bottom">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12 cursor-pointer">
                                    <div class="col-7 padding-left-0"><i
                                            class="fa fa-file-import padding-right-10 primary"></i>
                                        <a class="cursor-pointer"
                                            (click)="navigateToMatterTransaction(matterInformationExchangeTransaction)">{{matterInformationExchangeTransaction.transactionTypeStr}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="outstandingMatterInvoices.length > 0">
                        <dp-connect-invoice-list [matterInvoices]="outstandingMatterInvoices"
                            [matterId]="matterInfo.id"></dp-connect-invoice-list>
                    </ng-container>
                    <ng-container *ngFor="let matterWorkItem of getOutstandingUserMatterWorkItems()">
                        <div class="padding-bottom-5 padding-top-5 border-bottom">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12">
                                    <div class="col-5 padding-left-0"><i
                                            class="fa fa-file padding-right-10 primary"></i>{{matterWorkItem.name}}
                                    </div>
                                    <div class="col-2 padding-right-3 padding-left-0 text-right">Due: </div>
                                    <div class="col-4 col-lg-3 padding-right-0 padding-left-0">{{matterWorkItem.dueDate
                                        ? (matterWorkItem.dueDate | date : 'mediumDate') : 'N/A'}}</div>
                                    <div class="col-1 col-lg-2 padding-right-0 padding-left-0">
                                        <i *ngIf="matterWorkItem.isCompleted()" title="Completed"
                                            class="fa fa-check-circle green"></i>
                                        <i *ngIf="matterWorkItem.isOverdue() && !matterWorkItem.isCompleted()"
                                            title="Overdue" class="fa fa-exclamation-triangle warning-icon-color"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="outstandingMatterInformationExchangeTransactions?.length > 0">
                        <ng-container
                            *ngFor="let matterInformationExchangeTransaction of outstandingMatterInformationExchangeTransactions">
                            <div class="padding-bottom-5 padding-top-5 border-bottom">
                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="row col-12 cursor-pointer">
                                        <div class="col-7 padding-left-0"><i
                                                class="fa fa-pen padding-right-10 primary"></i>
                                            <a class="cursor-pointer"
                                                (click)="navigateToMatterTransaction(matterInformationExchangeTransaction)">{{matterInformationExchangeTransaction.transactionTypeStr}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-card>
            <mat-card class="mat-card-block"
                *ngIf="isTasksIconVisible() && (isSelectedSection('TASKS') || isBigScreen)">
                <ng-container *ngIf="getUserMatterWorkItems().length > 0">
                    <mat-card-title class="mat-card-header display-block padding-bottom-0">
                        <span class="padding-left-15"><i class="fa fa-file padding-right-10 primary"></i>Tasks</span>
                    </mat-card-title>
                    <div class="col-12">
                        <div class="row col-12 padding-left-0 padding-right-0">
                            <div class="row col-12">
                                <div class="col-7 padding-left-0"></div>
                                <div class="col-4 col-lg-3 bold padding-left-0">Due</div>
                                <div class="col-1 col-lg-2 padding-left-0"></div>
                            </div>
                        </div>
                        <ng-container *ngFor="let matterWorkItem of getOrderUserMatterWorkItems()">
                            <div class="padding-bottom-5 padding-top-5 border-bottom">
                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="row col-12">
                                        <div class="col-7 padding-left-0">{{matterWorkItem.name}}</div>
                                        <div class="col-4 col-lg-3 padding-right-0 padding-left-0">
                                            {{matterWorkItem.dueDate ? (matterWorkItem.dueDate | date : 'mediumDate') :
                                            'N/A'}}</div>
                                        <div class="col-1 col-lg-2 padding-right-0 padding-left-0">
                                            <i *ngIf="matterWorkItem.isCompleted()" title="Completed"
                                                class="fa fa-check-circle green"></i>
                                            <i *ngIf="matterWorkItem.isOverdue() && !matterWorkItem.isCompleted()"
                                                title="Overdue"
                                                class="fa fa-exclamation-triangle warning-icon-color"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="CirfTransactions.length > 0">
                    <div class="col-12 padding-top-10 padding-bottom-10"
                        *ngIf="matterInformationExchangeTransactions.length > 0">
                        <mat-card-title class="mat-card-header display-block padding-bottom-0">
                            <span><i class="fas fa-pen padding-right-10 primary"></i>Information Exchange</span>
                        </mat-card-title>
                        <ng-container *ngFor="let matterInformationExchangeTransaction of CirfTransactions">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12">
                                    <div class="col-7 padding-left-0"></div>
                                    <div class="col-3 bold padding-left-0">Last Updated</div>

                                </div>
                            </div>
                            <div class="padding-bottom-5 padding-top-5 border-bottom">
                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="row col-12 cursor-pointer">
                                        <div class="col-7 padding-left-0"><a class="cursor-pointer"
                                                (click)="navigateToMatterTransaction(matterInformationExchangeTransaction)">{{matterInformationExchangeTransaction.transactionTypeStr}}</a>
                                        </div>
                                        <div class="col-4 col-lg-3 padding-right-0 padding-left-0">
                                            {{matterInformationExchangeTransaction.transactionDate ?
                                            (matterInformationExchangeTransaction.transactionDate | date : 'mediumDate')
                                            : ''}}</div>
                                        <div class="col-1 col-lg-2 padding-right-0 padding-left-0">
                                            {{matterInformationExchangeTransaction.statusDisplay | titlecase}}</div>

                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

            </mat-card>
            <mat-card class="mat-card-block"
                *ngIf="isCorrespondenceIconVisible() && (isSelectedSection('CORRESPONDENCE') || isBigScreen)">
                <div class="col-12 padding-top-10 padding-bottom-10"
                    *ngIf="SharedDocumentsTransactions?.length > 0 && (isInboxVisible || isBigScreen)">
                    <mat-card-title class="mat-card-header display-block padding-bottom-0 padding-left-0">
                        <span class="padding-left-15"><i
                                class="fa fa-file-import  padding-right-10 primary"></i>Inbox</span>
                    </mat-card-title>
                    <ng-container *ngFor="let matterInformationExchangeTransaction of SharedDocumentsTransactions">
                        <div class="padding-bottom-5 padding-top-5 border-bottom">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12 cursor-pointer">
                                    <div class="col-7 padding-left-0"><a class="cursor-pointer"
                                            (click)="navigateToMatterTransaction(matterInformationExchangeTransaction)">{{matterInformationExchangeTransaction.transactionTypeStr}}</a>
                                    </div>
                                    <div class="col-3 padding-right-0 padding-left-0">
                                        {{matterInformationExchangeTransaction.transactionDate ?
                                        (matterInformationExchangeTransaction.transactionDate | date : 'mediumDate') :
                                        ''}}</div>
                                    <div class="col-2 padding-right-0 padding-left-0">
                                        {{matterInformationExchangeTransaction.historyItemRead}}</div>
                                    <!--                                    <div class="col-2">{{matterInformationExchangeTransaction.statusDisplay | titlecase}}</div>-->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="col-12 padding-top-10 padding-bottom-10"
                    *ngIf="messages?.length > 0 && (isSentItemsVisible || isBigScreen)">
                    <mat-card-title class="mat-card-header display-block padding-bottom-0 padding-left-0">
                        <span class="padding-left-15"><i class="fas fa-inbox padding-right-10 primary"></i>Sent
                            Items</span>
                    </mat-card-title>
                    <ng-container *ngFor="let msg of messages">
                        <div class="padding-bottom-5 padding-top-5 border-bottom cursor-pointer">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12 cursor-pointer">
                                    <div class="col-7 padding-left-0"><a class="cursor-pointer"
                                            (click)="openSendMessage(msg)">{{ (msg.message && msg.message.length > 40) ?
                                            (msg.message | slice:0:40) + '...' : (msg.message ? msg.message : '') }}</a>
                                    </div>
                                    <div class="col-4 col-lg-3 padding-right-0 padding-left-0">
                                        {{msg.lastUpdatedTimeStamp | date : 'mediumDate'}}</div>
                                    <div class="col-1 col-lg-2 padding-left-0"><mat-icon
                                            *ngIf="msg && msg.documentIdsIncludedInMessage && msg.documentIdsIncludedInMessage.length > 0">attachment</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="col-12 padding-top-10 padding-bottom-10"
                    *ngIf="matterDocuments?.length > 0 && (isUploadedFilesVisible || isBigScreen)">
                    <mat-card-title class="mat-card-header display-block padding-bottom-0 padding-left-0">
                        <span class="padding-left-15"><i class="fa fa-upload padding-right-10 primary"></i>Uploaded
                            Files</span>
                    </mat-card-title>
                    <div class="row col-12 padding-left-0 padding-right-0">
                        <div class="row col-12">
                            <div class="col-4 col-lg-4 padding-left-0">File Name</div>
                            <div class="col-4 col-lg-6 padding-left-0">File Description</div>
                            <div class="col-4 col-lg-2 padding-left-0">Uploaded Date</div>
                        </div>
                    </div>
                    <ng-container *ngFor="let doc of matterDocuments">
                        <div class="padding-bottom-5 padding-top-5 border-bottom">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12" (click)="openFile(doc)">
                                    <div class="col-4 col-lg-4 padding-left-0">{{doc.documentName}}</div>
                                    <div class="col-4 col-lg-6 padding-left-0">{{doc.description}}</div>
                                    <div class="col-4 col-lg-2 padding-left-0">{{doc.lastUpdatedTimeStamp | date:
                                        'mediumDate'}}</div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-card>

            <mat-card class="mat-card-block" *ngIf="sharedInvoices.length > 0">
                <ng-container>
                    <div class="col-12 padding-top-10 padding-bottom-10">
                        <mat-card-title class="mat-card-header display-block padding-bottom-0">
                            <span><i class="fas fa-file-invoice padding-right-10 primary"></i>Statements of
                                Account</span>
                        </mat-card-title>
                        <mat-card-content>
                            <dp-connect-invoice-list [matterInvoices]="sharedInvoices"
                                [matterId]="matterInfo.id"></dp-connect-invoice-list>
                        </mat-card-content>
                    </div>
                </ng-container>
            </mat-card>

            <mat-card class="mat-card-block"
                *ngIf="isReferralIconVisible() && (isSelectedSection('REFERRAL') || isBigScreen)">
                <mat-card-title class="mat-card-header display-block padding-bottom-0">
                    <span class="padding-left-10"><i
                            class="fa fa-registered padding-right-10 primary"></i>Referral</span>
                </mat-card-title>
                <div class="row col-12 padding-left-0 padding-right-0">
                    <div class="row col-12">
                        <div class="col-7 padding-left-0"></div>
                        <div class="col-3 bold padding-left-0">Last Updated</div>

                    </div>
                </div>
                <div class="col-12 padding-bottom-10">
                    <ng-container>
                        <div class="padding-bottom-5 padding-top-5 border-bottom">
                            <div class="row col-12 padding-left-0 padding-right-0">
                                <div class="row col-12 cursor-pointer">
                                    <div class="col-7 padding-left-0"><i class="fa fa-pen padding-right-10 primary"></i>
                                        <a class="cursor-pointer"
                                            (click)="navigateToMatterTransaction(referralTransaction)">{{referralTransaction.transactionTypeStr}}</a>
                                    </div>
                                    <div class="col-3 padding-right-0 padding-left-0">
                                        {{referralTransaction.lastUpdatedTimeStamp ?
                                        (referralTransaction.lastUpdatedTimeStamp | date : 'mediumDate') : ''}}</div>
                                    <div class="col-2 padding-right-0 padding-left-0">
                                        {{referralTransaction.statusDisplay}}</div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-card>
        </div>
        <div class="col-12 col-lg-4 padding-left-0 padding-right-0">
            <div class="col-12 padding-left-0 padding-right-0">
                <mat-card class="mat-card-block"
                    *ngIf="isAppointmentIconVisible() && ( isSelectedSection('APPOINTMENT') || isBigScreen)">
                    <mat-card-title class="mat-card-header display-block ">
                        <i class="fas fa-video padding-right-10 primary"></i>Upcoming Appointments
                    </mat-card-title>
                    <div class="col-md-12 font-15 padding-15 ">
                        <ng-container *ngFor="let appointment of uniqueAppointments">
                            <div class="padding-bottom-5 padding-top-5 border-bottom">
                                <div class="col-12 padding-left-0 padding-right-0">
                                    <div class="row col-12 padding-left-0 padding-right-0">
                                        <div class="col-9 padding-left-0 padding-right-0"
                                            *ngIf="isVirtualMeeting(appointment)">
                                            <a class="meeting-link" href="{{appointment.meetingLink}}" target="_blank">
                                                {{appointment.startDate | date : 'mediumDate'}}
                                                {{appointment.startTime}}-{{appointment.endTime }}
                                            </a>
                                        </div>
                                        <div class="col-9 padding-left-0 padding-right-0"
                                            *ngIf="!isVirtualMeeting(appointment)">
                                            {{appointment.startDate | date : 'mediumDate'}}
                                            {{appointment.startTime}}-{{appointment.endTime}}
                                        </div>
                                        <div class="col-3 padding-left-0 padding-right-0">
                                            <div *ngIf="!isVirtualMeeting(appointment)" class="font-16">
                                                {{appointment.eventSubtype}}</div>
                                            <div *ngIf="isVirtualMeeting(appointment)" class="font-16">
                                                <a class="meeting-link" href="{{appointment.meetingLink}}"
                                                    target="_blank">{{appointment.eventSubtype}}
                                                    <img class="{{getMettingIconSize(appointment.eventLocation)}}"
                                                        src="{{getMettingIcon(appointment.eventLocation)}}">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {{appointment.eventDescription}}
                                    </div>
                                    <div>
                                        {{appointment.scheduledForSolicitorName}}
                                    </div>

                                    <div *ngIf="isSyngrafiiVirtualMeeting(appointment)" class="font-16">
                                        <a class="meeting-link" href="{{appointment.meetingLink}}"
                                            target="_blank">Syngrafii Meeting Link</a>
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                    </div>
                </mat-card>
            </div>
            <div class="col-12 padding-left-0 padding-right-0">
                <mat-card class="mat-card-block"
                    *ngIf="isContactUsIconVisible() && (isSelectedSection('CONTACT_US') || isBigScreen) ">
                    <mat-card-title class="mat-card-header display-block ">
                        <span class="padding-left-10"><i class="fa fa-phone padding-right-10 primary"></i>Contact
                            Us</span>
                    </mat-card-title>
                    <div class="row col-12 margin-bottom-10 padding-left-15"
                        [ngClass]="{'mat-card-height' : logoImageUrl}">
                        <div class="col-12 text-center" *ngIf="logoImageUrl">
                            <img class="mat-card-logo-img img-fluid margin-bottom-10" src="{{logoImageUrl}}"
                                alt="firm logo">
                        </div>
                    </div>
                    <div *ngIf="matterInfo?.vendorSolicitor" class="col-12 padding-bottom-10">
                        <div class="border-bottom ">
                            <div class="padding-bottom-5">
                                <span class="bold">{{matterInfo?.vendorSolicitor?.name}}</span>
                            </div>
                            <!--                            <div class="d-none d-lg-block margin-bottom-10">-->
                            <!--                                <button mat-raised-button color="accent" (click)="openSendMessage(null)">-->
                            <!--                                    <mat-icon>cloud_upload</mat-icon>-->
                            <!--                                    Send a message to your Lawyer-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                            <div class="padding-bottom-5" *ngIf="matterInfo?.vendorSolicitor?.phone">
                                <span class="fa fa-phone padding-right-5"> </span>
                                <span>{{matterInfo?.vendorSolicitor?.phone}}</span>
                            </div>
                            <div class="padding-bottom-5" *ngIf="matterInfo?.vendorSolicitor?.email">
                                <span class="fa fa-envelope padding-right-5"> </span>
                                <span>{{matterInfo?.vendorSolicitor?.email}}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="matterInfo?.lawClerk" class="col-12 padding-bottom-10">
                        <div class="border-bottom ">
                            <div class="padding-bottom-5">
                                <span class="bold">{{matterInfo?.lawClerk?.name}}</span>
                            </div>
                            <div class="padding-bottom-5" *ngIf="matterInfo?.lawClerk?.phone">
                                <span class="fa fa-phone padding-right-5"> </span>
                                <span>{{matterInfo?.lawClerk?.phone}}</span>
                            </div>
                            <div class="padding-bottom-5" *ngIf="matterInfo?.lawClerk?.email">
                                <span class="fa fa-envelope padding-right-5"> </span>
                                <span>{{matterInfo?.lawClerk?.email}}</span>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 padding-bottom-10" *ngIf="matterInfo?.lawFirm">
                        <div class="border-bottom ">
                            <div class="padding-bottom-5">
                                <span class="bold">{{matterInfo?.lawFirm}}</span>
                            </div>
                            <div class="padding-bottom-5">
                                <span>{{matterInfo?.lawFirmAddress?.getAddressText(true, true, false, true)}} </span>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 padding-bottom-35 " *ngIf="isInitiateMessageIconVisible()">
                        <div class="d-none d-md-block d-lg-block">
                            <button mat-raised-button color="accent-bg-white" (click)="openSendMessage(null)">
                                <mat-icon>cloud_upload</mat-icon>
                                Send Secure Message to Lawyer
                            </button>
                        </div>
                    </div>
                </mat-card>
            </div>

        </div>
    </div>

    <div class="footer-block d-block d-md-none summary-page-bottom">
        <!--    This flowing will be hidden on large devices.-->
        <mat-nav-list class="list-horizontal col-12 padding-left-0 padding-right-0">
            <mat-list-item *ngIf="isOutstandingIconVisible()"
                class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('OUTSTANDING')}"
                (click)="selectMatterMobileSection('OUTSTANDING')">
                <div class="text-center font-20">
                    <div class="fa fa-clock"></div>
                </div>
                <div class="mat-list-text">Outstanding</div>
            </mat-list-item>

            <mat-list-item *ngIf="isTasksIconVisible()" class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('TASKS')}" (click)="selectMatterMobileSection('TASKS')">
                <div class="text-center font-20">
                    <div class="fa fa-file"></div>
                </div>
                <div class="mat-list-text">Tasks</div>
            </mat-list-item>
            <mat-list-item *ngIf="isReferralIconVisible()" class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('REFERRAL')}" (click)="selectMatterMobileSection('REFERRAL')">
                <div class="text-center font-20">
                    <div class="fa fa-registered"></div>
                </div>
                <div class="mat-list-text">Referral</div>
            </mat-list-item>
            <mat-list-item *ngIf="isCorrespondenceIconVisible()" [matMenuTriggerFor]="correspondenceMenu"
                class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('CORRESPONDENCE')}">
                <div class="text-center font-20">
                    <div class="fa fa-bars"></div>
                </div>
                <div class="mat-list-text">Correspondence</div>
                <mat-menu #correspondenceMenu="matMenu">
                    <button mat-menu-item *ngIf="SharedDocumentsTransactions?.length > 0" (click)="selectInbox()">
                        <span>Inbox</span>
                    </button>
                    <button mat-menu-item *ngIf="messages?.length > 0" (click)="selectSentItems()">
                        <span>Sent Items</span>
                    </button>
                    <button mat-menu-item *ngIf="matterDocuments?.length > 0" (click)="selectUploadedFiles()">
                        <span>Uploaded Files</span>
                    </button>
                </mat-menu>
            </mat-list-item>

            <mat-list-item *ngIf="isAppointmentIconVisible()"
                class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('APPOINTMENT')}"
                (click)="selectMatterMobileSection('APPOINTMENT')">
                <div class="text-center font-20">
                    <div class="fa fa-video"></div>
                </div>
                <div class="mat-list-text">Appointments</div>
            </mat-list-item>
            <mat-list-item *ngIf="isContactUsIconVisible()"
                class="{{getListItemClass()}} padding-left-0 padding-right-0"
                [ngClass]="{'active' : isSelectedSection('CONTACT_US')}"
                (click)="selectMatterMobileSection('CONTACT_US')">
                <div class="text-center font-20">
                    <div class="fa fa-phone"></div>
                </div>
                <div class="mat-list-text">Contact Us</div>
            </mat-list-item>

            <mat-list-item class="{{getListItemClass()}} padding-left-0 padding-right-0"
                *ngIf="isInitiateMessageIconVisible()" (click)="initiateMessage()">
                <div class="text-center font-20">
                    <div class="fa fa-envelope"></div>
                </div>
                <div class="mat-list-text">Send<br />Message</div>
            </mat-list-item>
        </mat-nav-list>
    </div>


    <div class="back-to-top-block d-12 d-lg-none ">
        <button id="backToTopBtn" title="Go to top" #backToTopBtn (click)="backToTop()"><i class="fa fa-arrow-up"></i>
        </button>
    </div>
</div>